import { Component, Input } from '@angular/core';
import { HomeConfig } from 'src/app/model/homeConfig';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.css'],
})
export class BannerComponent {
  imageUrl = environment.apiUrl;
  @Input() config!: HomeConfig;
  firstHalfText: string = '';
  secondHalfText: string = '';

  ngOnInit(): void {
    if (this.config?.bannerText) {
      const words = this.config.bannerText.split(' ');
      const middle = Math.ceil(words.length / 2);
      this.firstHalfText = words.slice(0, middle).join(' ');
      this.secondHalfText = words.slice(middle).join(' ');
    } else {
      this.firstHalfText = 'ULTIMATE';
      this.secondHalfText = 'SPORTSWEAR';
    }
  }

  get bannerText(): string {
    return this.config?.bannerText || '';
  }
}
